import { useEffect, useState } from 'react'

/**
 * Planli bakim durumu (bkz. `hedefai_app/services/maintenance.py`).
 *
 * `none`    - normal calisma.
 * `warning` - is birazdan baslayacak; kullanici hala calisabiliyor.
 * `active`  - is basladi; uretim kabul edilmiyor.
 */
export interface MaintenanceInfo {
  state: 'none' | 'warning' | 'active'
  starts_at: string | null
  expected_end_at: string | null
  message: string | null
}

const NONE: MaintenanceInfo = {
  state: 'none',
  starts_at: null,
  expected_end_at: null,
  message: null,
}

export async function fetchMaintenance(): Promise<MaintenanceInfo> {
  const response = await fetch('/api/maintenance', { headers: { Accept: 'application/json' } })
  if (!response.ok) throw new Error(String(response.status))
  return (await response.json()) as MaintenanceInfo
}

/**
 * Durumu periyodik okur.
 *
 * ## Neden `fetch`, uygulamanin `apiJson`'i degil
 *
 * Bu uc kimlik gerektirmiyor ve oturum suresi dolmus bir kullanicida da
 * calismali: bakim sirasinda "giris yapamiyorum" sanan kullanici tam olarak
 * kacinmak istedigimiz durum.
 *
 * ## Hata SESSIZ
 *
 * Sunucu gercekten kapandiysa istek patliyor. Bunu "bakim var" saymiyoruz:
 * ag kesintisi de ayni hatayi verir ve kullaniciyi yanlis bilgilendirirdi.
 * Son bilinen durum korunuyor - zaten bakim basladiysa `active` elimizde.
 */
export function useMaintenance(intervalMs = 60_000): MaintenanceInfo {
  const [info, setInfo] = useState<MaintenanceInfo>(NONE)

  useEffect(() => {
    let alive = true
    const load = () => {
      fetchMaintenance()
        .then((next) => {
          if (alive) setInfo(next)
        })
        .catch(() => {})
    }
    load()
    const timer = window.setInterval(load, intervalMs)
    return () => {
      alive = false
      window.clearInterval(timer)
    }
  }, [intervalMs])

  return info
}
